/*
	GETTERS
*/
//------------------------------------------------------------
// IMPORTS
//------------------------------------------------------------
//------------------------------------------------------------
// GET USER LEVEL
//------------------------------------------------------------

const userLevel = (state) => { // change to getUserLevel
	return state.level < 10 ? '0'+state.level : state.level;
}

//------------------------------------------------------------
// EXPORT
//------------------------------------------------------------

export default {
	userLevel,
};